module.exports = __webpack_public_path__ + "img/logo.6dff5e40.svg";